if (typeof window !== 'undefined') {
  if (typeof window.process === 'undefined') {
    window.process = { env: {} }
  } else if (!window.process.env) {
    window.process.env = {}
  }
}
